import { render } from "./PublicLeaderboard.vue?vue&type=template&id=cdc10280&ts=true"
import script from "./PublicLeaderboard.vue?vue&type=script&lang=ts"
export * from "./PublicLeaderboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__